/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.partners.modals.selectList.controllers', [
  'ui.bootstrap',
  'acme.common.service.api',
  'acme.common.service.helpers',
  'acme.common.directive.scrollableSelectList'
])

.controller('PartnersModalsSelectListController', ['$scope', '$uibModalInstance', '$timeout', 'ApiService', 'HelpersService', 'currentOrg', function($scope, $uibModalInstance, $timeout, ApiService, HelpersService, currentOrg) {

    $scope.partnersModalsSelectList = {

      list: [],
      model: {},
      searchQuery: '',
      selected: {
        id: '',
        name: ''
      },

      init: function() {

        if (currentOrg.id) {
          this.model.id = currentOrg.id;
        }
        if (currentOrg.name) {
          this.model.name = currentOrg.name;
        }

        this.getOrganizations();
        $scope.$on('ScrollableSelectList::Done', this.onScrollableSelectListDone);
      },

      getOrganizations: function() {
        var self = $scope.partnersModalsSelectList,
            props = HelpersService.getPaginator();

        props.category = '';

        ApiService.partners.list(props).then(function(response) {
          self.list = self.process(response.data.payload.list);

          self.categorized = angular.copy(self.list);
        }, this.error.init);
      },

      process: function(partners) {
        var i, ii,
          j, jj;

        for (i=0,ii=partners.length;i<ii;i++) {
          partners[i].name = partners[i].company.name;

          if (partners[i].primaryContact) {
            partners[i].primaryContact.contactName = '';
            if (partners[i].primaryContact.firstName) {
              partners[i].primaryContact.contactName = partners[i].primaryContact.firstName;
            }
            if (partners[i].primaryContact.lastName) {
              partners[i].primaryContact.contactName += ' ' + partners[i].primaryContact.lastName;
            }
          }else{
            console.log('PartnersListController:process !partners[i].primaryContact', partners[i]);
            partners[i].primaryContact = {};
            partners[i].primaryContact.contactName = '';
          }
          for (j=0,jj=partners[i].requests.length;j<jj;j++) {
            partners[i][partners[i].requests[j].type] = {
              status: HelpersService.cap(partners[i].requests[j].status)
            };
          }
        }

        return partners;
      },

      done: function() {
        $uibModalInstance.close(this.selected);
      },

      cancel: function () {
        $uibModalInstance.dismiss('cancel');
      },

      success: {
        init: function(response) {}
      },

      error: {
        init: function(response) {}
      },

      onScrollableSelectListDone: function(e, data) {
        $scope.partnersModalsSelectList.done();
      }

    };

    $scope.partnersModalsSelectList.init();

}]);